import { createContext } from "react";
import type { RemoteConfigContextType } from "./RemoteConfigContext.types";

const RemoteConfigContext = createContext<RemoteConfigContextType | undefined>(undefined);
RemoteConfigContext.displayName = "RemoteConfigContext";

export default RemoteConfigContext;
